<template>     
  <v-card flat>    
    <v-card-text>
      <h3 class="text-xs-center">Angket Orang Tua</h3>
      <p class="text-xs-center my-3">Terima kasih Bapak/Ibu telah mengisi halaman ini dengan jujur, jelas dan lengkap</p>      
    </v-card-text>
    <v-toolbar :color="jilid.color ? jilid.color : 'cyan'" flat dark dense>
      <h3>Questionnaire</h3><v-spacer/>              
    </v-toolbar>
    <v-progress-linear class="ma-0 pa-0" :indeterminate="true" v-if="loadingData"></v-progress-linear>
    <v-card-text>
      <table>
        <template v-for="(quetion, i) in fm.responDtls">
          <tr :key="i">
            <td valign="top" class="text-center body-1">{{quetion.no}}.</td>
            <td valign="top">
              <p><span class="body-1" v-html="quetion.question"></span><br/>
                <template v-if="quetion.type === 1">
                  <div class="mb-4 mt-2">
                    <template v-for="(opt,n) in quetion.option">
                      <input :key="n" type="radio" v-model="quetion.answer_id" :value="opt.id" class="mr-2" /> <span :key="n+'span'" @click="quetion.answer_id=opt.id">{{opt.key+'. '+opt.value}}</span> <br :key="n+'br'" />                    
                    </template>
                  </div>
                  <!--<v-radio-group v-model="quetion.answer_id" hide-details class="mt-0">
                    <v-radio v-for="(opt,n) in quetion.option" :key="n"
                      :label="opt.key+'. '+opt.value" :value="opt.id"
                    ></v-radio>
                  </v-radio-group>-->
                </template>
                <template v-else-if="quetion.type === 2">
                  <v-checkbox v-for="(opt,n) in quetion.option" v-model="quetion.answer_jsonid[n]" :key="n" class="mt-1" :label="opt.key+'. '+opt.value" :value="opt.id" hide-details></v-checkbox>            
                </template>
                <template v-else-if="quetion.type === 3">
                  <v-text-field v-for="(opt,n) in quetion.option" v-model="quetion.answer_jsonvalue[n]" :key="n" type="text" :label="opt.key" small hide-details style="max-width:400px;margin-bottom:4px;" >
                    <span :set="quetion.answer_jsonkey[n] = opt.key"></span>
                  </v-text-field>
                </template>
              </p>
            </td>
          </tr>
        </template>
      </table>              
    </v-card-text>   
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn v-if="tingkat_id == 1" color="primary" :loading="loading" @click="saveAngket()">Save</v-btn>
      <v-btn v-else color="primary" :loading="loading" @click="saveAngket()">Save & Continue</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import Model from '@/models/dashboard';
import User  from '@/util/models/User';
const  model = new Model();

export default {
  name:'step4',  
  props:{
    stepke:{
      type: Number,
      default: null,
    },
  },
  data:()=>({  
    stepkeLocal : null,
    conti : false,
    user : User.attributes(),
    quetionnaires : [],
    calonQuetionnaire : [],
    fm : {
      client_id : null,
      jilid_id : null,
      responden_id : null,
      code : null,
      date : null,
      name : null,
      phone : null,
      gender : null,
      responDtls:[]
    },    
    jilid:{},
    tingkat_id : 2,
    jilid_id: 1,    
    loading : false,
    loadingData : true
  }),
  watch:{
    stepke(newStep){
      this.stepkeLocal = newStep;      
      this.init()
    },
    stepkeLocal(newStep){
      this.$emit('update:stepke', newStep);
    }
  },  
  mounted(){    
    this.init();     
  },
  methods:{
    init(){     
      model.viewAdministrasi({id:this.user.id}).then(data=>{
        //Object.assign(this.fm, data);        
        this.tingkat_id = data.tingkat_id; 
        this.fm.phone = data.telepon
        this.fm.name = data.nama
        this.fm.gender = data.gender == 1 ? 'L' : 'P';
        this.fm.responden_id = data.id
        this.loadingData = true
        if(data.tingkat_id == 1){
          this.jilid_id = 2
        } else {
          this.jilid_id = 1
        }
        model.quetionnaires({id:this.jilid_id, expand:'quetionnaires,responDtls'}).then(jilid=>{ 
          this.fm.responDtls = [];
          this.loadingData = false
          this.fm.jilid_id = jilid.id
          this.jilid = jilid;        
          this.jilid.quetionnaires.forEach(item=>{         
            let question = jilid.responDtls.find(x=>x.quetionnaire_id == item.id);
            if(question){
              question.jilid_id = this.jilid.id;
              question.no = item.no;
              question.type = item.type;
              question.question = item.question;
              question.option = item.option;      
              this.fm.responDtls.push(question);              
            } else {
              this.fm.responDtls.push({
                quetionnaire_id:item.id,
                jilid_id:this.jilid.id,
                no:item.no,
                type:item.type,
                question:item.question,
                option:item.option,
                answer_id:null,
                answer_key:null,
                answer_value:null,
                answer_jsonid:[],
                answer_jsonkey:[],
                answer_jsonvalue:[]
              })
            }           
          });  
        });
      });  
    },
    
    saveAngket(sd = false){
      this.loading = true;
      model.saveAngket(this.fm, {id:this.jilid_id}).then(res=>{
        if(res.status === 200 && !sd){
          this.$emit('update:stepke', 5);
        }        
        this.loading = false;
      });
    }
    
  }
};
</script>
<style>

</style> 

